import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';
import { Trans, useTranslation } from 'react-i18next';

const BACKENDURL = window.reactInit.backendurl+'/entry';

export default function Success(){
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const auth = useAuthUser();
    const token = useAuthHeader();
    const [ error, setError ] = useState({});
    const [ success, setSuccess ] = useState(false);

    const handleResend = ()=>{
        console.log('resend email');
        const params = {
            email: auth.email,
            lang: i18n.resolvedLanguage,
            resend: true
        };
        fetch(BACKENDURL+'/resend',{ method:'POST',
                body:new URLSearchParams(params),
                headers:{'Authorization':token} } )
            .then( resp => resp.json() )
            .then( resp => {
                
                if (resp.success) {
                    // continue. 
                    console.log('submitted');
                    setSuccess(true);
                } else {
                    console.log('set error',resp.status);
                    setError(resp);
                }
            } )
            .catch( err => setError(err) );
    }

    useEffect(()=>{
        // refresh submitted state from backend.
        
        fetch(BACKENDURL+'/refresh',{ method:'POST',
                headers:{'Authorization':token} } )
            .then( resp => resp.json() )
            .then( resp => {
                if (resp.status) {
                    console.log('ERROR!',resp.status);
                    setError(resp);
                    return;
                }
                console.log('refresh',resp.email);
                auth.submitted = resp.submitted;

                if (!auth.submitted) navigate('/application');
            } )
    },[]);

    useEffect( ()=>{
        if (!auth.dotracking) return;
        if (document.querySelector('#track-script')) return;
            
        auth.dotracking = null;

        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.id = 'track-script';
        s.async = true;
        s.innerHTML = "fbq('trackCustom', 'Submit Application');";
        document.head.appendChild(s);
    },[]);

    return (
        <Container fluid as='main' className="rules">
            <Row>
                <Col className="text-sm-center">
                    <h2>{t('success.title')}</h2>
                    <p>{t('success.subtitle')}</p>
                </Col>
            </Row>
            <Row className="skinny-row">
                <Col>
                    <p>{t('success.body')}</p>
                    <p className="text-center">
                        <Link to="/review" className="text-link">{t('success.review-cta')}</Link>
                    </p>
                    <p className="text-center">
                        <a download={true} href={`${BACKENDURL}/preview/?_id=${auth._id}&lang=${i18n.resolvedLanguage}&dl=1`} className="button">{t('success.cta')}</a>
                    </p>
                    <p className="text-center">
                        <Trans i18nKey="success.resend" components={[<span className="text-link" onClick={handleResend}/>]} />
                    </p>
                    { error.status &&
                        <p className="error text-center mt-3">{t('errors.'+error.status)}</p>
                    }
                    { success &&
                        <p className="text-center mt-3">{t('success.resent')}</p>
                    }
                </Col>
            </Row>
        </Container>
    );
}